import { Injectable } from '@angular/core';
import { JwtHelper } from 'angular2-jwt';
import { Usuario } from '../../../model/interface/Usuario';

@Injectable()
export class AuthService {
  constructor() { }


  public setToken(token: string) {
    localStorage.setItem('access_token', token);
  }

  public getToken(): string {
    return localStorage.getItem('access_token');
  }

  public deleteToken() {
    localStorage.removeItem('access_token');
  }

  public isLoged(): boolean {
    const helper = new JwtHelper();
    const token = this.getToken();
    if (token) {
      const isValid = !helper.isTokenExpired(token);
      if (!isValid) {
        this.deleteToken();
      }
      return isValid;
    }
    return false;
  }

  public getUser(): Usuario {
    const helper = new JwtHelper();
    const token = this.getToken();

    if (token) {
      const decodedToken = helper.decodeToken(token);
      return {
        'id': decodedToken.id,
        'nombre': decodedToken.nombre,
        'apellido': decodedToken.apellido,
        'email': decodedToken.email,
        'roles': decodedToken.roles
      };
    }
    return {};

  }

  public isOnlyVendedora() {
    const user =  this.getUser();
    const vendedora =  user.roles.find((o) => o.constante === 'VENDEDOR');
    const admin = user.roles.find((o) => o.constante === 'ADMIN');

    return vendedora && !admin;
  }

  public isAdmin() {
    const user =  this.getUser();
    const admin = user.roles.find((o) => o.constante === 'ADMIN');
    return !!admin;
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/auth/auth.service.ts